<script setup>
import { ref, watch } from "vue";

const props = defineProps({
    elId: {
        Type: String,
        default: "",
    },
    label: String,
    value: String | Number,
    type: {
        type: String,
        default: "text",
    },
    unit: {
        type: String,
        default: "",
    },
    widthLabel: {
        type: Number,
        default: 3,
    },
    widthInput: {
        type: Number,
        default: 9,
    },
    additionalAttr: Object,
    error: String,
});

const emit = defineEmits(["update:value"]);

const inputValue = ref(isNaN(props.value) ? "" : props.value);

watch(
    () => props.value,
    (newValue) => {
        inputValue.value =
            isNaN(newValue) && props.type == "number" ? "" : newValue;
    }
);

watch(inputValue, (newValue) => {
    emit(
        "update:value",
        props.type == "number" ? parseInt(newValue) : newValue
    );
});

const changeToEmpty = (curValue) => {
    inputValue.value = curValue == 0 && props.type == "number" ? "" : curValue;
};

const changeToZero = (curValue) => {
    inputValue.value = curValue == "" && props.type == "number" ? 0 : curValue;
};
</script>

<template>
    <div class="row align-items-lg-center" :class="{ 'question-error': error }">
        <label
            :for="elId"
            :class="
                'col-lg-' +
                widthLabel +
                ' label-size text-lg-end fw-bold mb-lg-0 mb-2'
            "
        >
            {{ label }}
        </label>
        <div :class="'col-lg-' + widthInput + ' custom-position-relative'">
            <input
                :id="elId"
                :type="type"
                class="form-control"
                @focus="changeToEmpty($event.target.value)"
                @blur="changeToZero($event.target.value)"
                v-model="inputValue"
                :class="{ 'is-invalid': error, 'text-end': type == 'number' }"
                v-bind="additionalAttr"
            />

            <span v-if="unit != ''" class="custom-input-unit">{{ unit }}</span>
        </div>
    </div>
    <div v-if="error" class="row">
        <div
            :class="
                'col-lg-' +
                widthInput +
                ' offset-lg-' +
                widthLabel +
                ' text-danger font-error'
            "
        >
            {{ error }}
        </div>
    </div>
</template>
